+(function ($) {
  "use strict";

  /* css-tricks.com's iOS viewport-height set trick => https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ */
  $(window).on("load resize", function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  });
  $(window).on("load orientationchange", function () {
    if (window.matchMedia("(orientation: portrait)").matches) {
      // only fire when we're in portrait mode
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vhHomepagehero", vh + "px");
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    var $body = $("body"),
      $window = $(window),
      $toggleMenu = $(".toggle-menu");

    $body.addClass("page-loaded");
    if (!drupalSettings?.user?.uid) {
      $body.find(".apb-admin").remove();
    }

    function isMobile() {
      try {
        document.createEvent("touchevent");
        return true;
      } catch (e) {
        return false;
      }
    }

    $window.scroll(function () {
      if ($window.scrollTop() < 20) $body.removeClass("not-top");
      else {
        $body.addClass("not-top");
      }
    });

    var isMobile = isMobile();
    $toggleMenu.on("click", function (e) {
      e.preventDefault();
      $body.toggleClass("state-big-menu");
    });

    $(".apb-add").on("click", function (e) {
      e.preventDefault();

      var target = $(this).attr("data-target");
      var type = $(this).attr("data-type");

      var data = {
        type: type,
        targetID: target,
      };

      axios
        .post("/apb/create.json", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (response.data.data.redirect) {
            window.location.replace(response.data.data.redirect);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    });

    $(".fold").on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("data-target");
      $(".apb-add-elements").toggleClass("visible");
      $(".apb-overlay").toggleClass("visible");
    });

    $(".show-all-button").on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("data-target");
      $(`.hidden-show-more-${target}`).show();
      $(this).remove();
    });

    $(".apb-overlay").click(function (event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".apb-add-elements").length) {
        $(".apb-add-elements").toggleClass("visible");
        $(".apb-overlay").toggleClass("visible");
      }
    });

    /* Content blocks */
    var activeContentItem0 = $(".me-block-content .pos-0").attr("id"),
      activeContentItem1 = $(".me-block-content .pos-1").attr("id"),
      activeContentItem2 = $(".me-block-content .pos-2").attr("id");

    $(".me-block-content .text a").hover(function (e) {
      e.preventDefault();
      $(".me-block-content .text a").removeClass("active");
      $(this).addClass("active");
      var newActive = "img-" + $(this).attr("data-id");

      // Find position of new active
      if (activeContentItem0 == newActive) {
        // Do nothing
      } else if (activeContentItem1 == newActive) {
        // Set current active to middle position
        $("#" + activeContentItem1)
          .removeClass("pos-1")
          .addClass("pos-0");
        $("#" + activeContentItem0)
          .removeClass("pos-0")
          .addClass("pos-1");
      } else if (activeContentItem2 == newActive) {
        // Set current active to middle position
        $("#" + activeContentItem2)
          .removeClass("pos-2")
          .addClass("pos-0");
        $("#" + activeContentItem0)
          .removeClass("pos-0")
          .addClass("pos-1");
        $("#" + activeContentItem1)
          .removeClass("pos-1")
          .addClass("pos-2");
      }

      activeContentItem0 = $(".me-block-content .pos-0").attr("id");
      activeContentItem1 = $(".me-block-content .pos-1").attr("id");
      activeContentItem2 = $(".me-block-content .pos-2").attr("id");
    });

    /* Image sliders */
    var activeGallery = "";

    $(".show-gallery").on("click", function (e) {
      e.preventDefault();
      var newGallery = $(this).attr("data-gallery");
      console.log("click", newGallery);

      if (activeGallery !== "") {
        $("#" + activeGallery).removeClass("visible");
        setTimeout(function () {
          $("#" + newGallery).addClass("visible");
          activeGallery = newGallery;
        }, 600);
      } else {
        $("#" + newGallery).addClass("visible");
        activeGallery = newGallery;
      }
    });

    $(".image-slider-close").on("click", function (e) {
      e.preventDefault();
      $("#" + activeGallery).removeClass("visible");
      activeGallery = "";
    });

    $(document).keyup(function (e) {
      if (e.keyCode === 27) $(".image-slider-close").click();
    });

    /* $('.image-slider').on('click', function (e) {
       if ($(e.target).closest(".swiper-wrapper").length === 0) {
         e.preventDefault();
         if (activeGallery !== '') {
           $(this).removeClass('visible');
           activeGallery = '';
         }
       }
     })*/

    var imageTextSwiper = new Swiper(
      ".me-block-image-text .image-slider-container",
      {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    );

    /* Newsletter */
    $("#subscribe-news").on("click", function (e) {
      e.preventDefault();
      var email = $("#MERGE0").val();
      if (email == "") {
        $("#MERGE0").addClass("required-error");
      } else {
        $("#MERGE0").removeClass("required-error");
        window.location.href = `https://manengenius.us14.list-manage.com/subscribe?u=b7cf5c6e0936c6469c40cf364&id=b09947c735&MERGE0=${email}`;
        $("#MERGE0").val("");
      }
    });

    $("#the-form").submit(function (e) {
      e.preventDefault();
      var email = $("#MERGE0").val();
      if (email == "") {
        $("#MERGE0").addClass("required-error");
      } else {
        $("#MERGE0").removeClass("required-error");
        window.location.href = `https://manengenius.us14.list-manage.com/subscribe?u=b7cf5c6e0936c6469c40cf364&id=b09947c735&MERGE0=${email}`;
        $("#MERGE0").val("");
      }
    });

    /* Project filters */
    var $projectFilters = $(
        "body .expertise-filters, body .location-filters, body .hoursperweek-filters, body .level-filters"
      ),
      $filters = $projectFilters.find(".values a"),
      filtersActive = false,
      $openFilters = $(".open-filters"),
      curFilter = 0,
      curFilterLabel = "";

    $filters.on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("data-target");
      const filterType = $(this).attr("data-filter-type");
      if (curFilter == target) {
        filtersActive = false;
        curFilter = 0;
        $projectFilters.find("a.filter-value").removeClass("selected");
        $projectFilters.removeClass("selected");
        $(`body .${filterType}-filter`).addClass("active");
        // $openFilters.find("span").html("Alle expertises");
        // $openFilters.removeClass("active");
        setTimeout(function () {
          $(`body .${filterType}-filters`).removeClass("visible");
        }, 300);
      } else {
        $(`body .${filterType}-filter`).removeClass("active");
        $(`body .${filterType}-filter.${target}`).addClass("active");
        $projectFilters.addClass("selected");
        $(`.${filterType}-filters a.filter-value`).removeClass("selected");
        $(this).addClass("selected");
        filtersActive = true;
        curFilter = target;
        curFilterLabel = $(this).attr("data-label");
        setTimeout(function () {
          $(`body .${filterType}-filters`).removeClass("visible");
        }, 300);
        $(`body .open-filters[data-filter-type='${filterType}']`)
          .find("span")
          .html(curFilterLabel);
        $(`body .open-filters[data-filter-type='${filterType}']`).addClass(
          "active"
        );
      }
    });

    $(".clear-filters").on("click", function (e) {
      const filterType = $(this).attr("data-filter-type");
      e.preventDefault();
      filtersActive = false;
      curFilter = 0;
      $("a.filter-value").removeClass("selected");
      $(`body .${filterType}-filters`).removeClass("selected");
      $(`body .${filterType}`).addClass("active");

      switch (filterType) {
        case "expertise":
          $(`body .open-filters[data-filter-type='${filterType}'`)
            .find("span")
            .html("Alle expertises");
          break;
        case "location":
          $(`body .open-filters[data-filter-type='${filterType}'`)
            .find("span")
            .html("Alle regios");
          break;
        case "level":
          $(`body .open-filters[data-filter-type='${filterType}'`)
            .find("span")
            .html("Alle niveaus");
          break;
        case "hoursperweek":
          $(`body .open-filters[data-filter-type='${filterType}'`)
            .find("span")
            .html("Zowel parttime als fulltime");
          break;
      }
      $openFilters.removeClass("active");
      setTimeout(function () {
        $(`body .${filterType}-filters`).removeClass("visible");
      }, 300);
    });

    $(".close-filters").on("click", function (e) {
      e.preventDefault();
      $projectFilters.removeClass("visible");
    });

    $openFilters.on("click", function (e) {
      e.preventDefault();
      const filterType = $(this).attr("data-filter-type");

      $(`body .${filterType}-filters`).addClass("visible");
    });

    $("body .phone-safe").on("click", function (e) {
      e.preventDefault();
      const phoneNumber = $(this).attr("data-number");
      if ($(this).attr("data-number-unlocked") === "true") {
        window.open(`tel:${phoneNumber}`);
      } else {
        $(this).attr("data-number-unlocked", "true");
        $(this).find(".number").html(phoneNumber);
      }
    });

    $("body .mail-safe").on("click", function (e) {
      e.preventDefault();
      const emailAddress = $(this).attr("data-email");
      if ($(this).attr("data-email-unlocked") === "true") {
        window.open(`mailto:${emailAddress}`);
      } else {
        $(this).attr("data-email-unlocked", "true");
        $(this).find(".email").html(emailAddress);
      }
    });

    // Search
    var $searchForm = $("#search-form"),
      $searchInput = $("#search-input"),
      $contactLink = $("#contact-link");

    // $searchInput.on('focus', function (e) {
    //   // Get position
    //   var position = $(this).offset();
    //   var width = $(this).outerWidth();
    //   var windowWidth = $window.width();
    //   var newWidth = windowWidth < 1055 ? 'calc(100% - 51px)' : '190px';
    //   var newRight = windowWidth < 1055 ? '52px' : '0px';
    //   // Give contact link margin to stay at same position
    //   $contactLink.css({
    //     opacity:0
    //     // marginRight: width+20+'px'
    //   })
    //   setTimeout(function() {
    //     $contactLink.hide();
    //     $searchForm.css({
    //       right: newRight,
    //       top: '0',
    //       position: 'absolute',
    //       width: newWidth
    //     });
    //     $searchInput.css({
    //       width: newWidth
    //     });
    //   }, 800)

    // })

    // $searchInput.on('blur', function (e) {
    //   $contactLink.hide();

    //   $searchInput.css({
    //     width:'70px'
    //   });

    //   $searchForm.css({
    //     width:'90px'
    //   });

    //   // Give contact link margin to stay at same position

    //   setTimeout(function() {
    //     $searchForm.css({
    //       right: 'auto',
    //       top: 'auto',
    //       position: 'relative',
    //     });
    //     $contactLink.show().css({
    //       opacity:1
    //       // marginRight: width+20+'px'
    //     })
    //   }, 800)

    // })

    $(".contact-circle").on("click", function () {
      $(this).toggleClass("info-visible");
    });

    $(".show-contact-info").on("click", function (e) {
      e.preventDefault();
      $(this)
        .parent(".relative")
        .children(".contact-info")
        .toggleClass("visible");
    });

    $("#search-form").submit(function (e) {
      e.preventDefault();
      var value = $("#search-input").val();
      window.location.href = "/zoeken/" + value;
    });
  });
})(jQuery, Drupal, drupalSettings);
